module.exports = __webpack_public_path__ + "static/img/006城市名片6.e32f3b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/006城市名片6.jpg
// module id = I6wl
// module chunks = 0